import { IonContent, IonInput, IonPage, IonText, IonTextarea, IonSpinner } from "@ionic/react"
import Head from "../Header";
import Sidebar from "../Sidebar";
import { useEffect, useState, useMemo, } from "react";
import { useHistory, useLocation } from "react-router";
import { calendar } from 'ionicons/icons';
// import DatePicker from "react-datepicker";

import service from "../../Service/service";
import DataTable from "react-data-table-component";
import moment from "moment";
import swal from 'sweetalert';
import { Modal } from "react-bootstrap";
import { error } from "console";

const EmpLeaveUpdateView = () => {
      const history = useHistory();
      const location: any = useLocation();
      const [ids, setids] = useState("")
      const [Id] = useState(localStorage.getItem("SignupEmpId"));
      useEffect(() => {
            if (location.state && location.state.Id) {
                console.log(location);
                setids(location.state.Id);
                localStorage.setItem('storedId', location.state.Id);
            } else {
                const storedId = localStorage.getItem('storedId');
                if (storedId) {
                    setids(storedId);
                }
            }
        }, [location.state]);

      // const [empCode] = useState(localStorage.getItem("empCode"));
      const [fromDate, setFromDate] = useState("");
      const [toDate, setToDate] = useState("");
      const [loading, setloading] = useState(false)
      const [data, setData] = useState([]);

      const dataArray = Array.isArray(data) ? data : [data];
      dataArray.forEach((item: any, index: any) => {
            item.serial = index + 1;
      });


      const [filterText, setFilterText] = useState("");
      const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
      /*.................... View ..................*/
      const [modalopen, setModalopen] = useState(false);

      const [leaveType, setLeaveType] = useState("");
      const [status, setStatus] = useState("");
      const [fDate, setFDate] = useState("");
      const [empName, setEmpName] = useState("");
      const [tDate, setTDate] = useState("");
      const [leaveReason, setLeaveReason] = useState("");
      const [reportingPerson, setReportingPerson] = useState("");
      const [NoOfDays, setNoOfDays] = useState("");
      const [remarks, setRemarks] = useState("");
      const [leavestatus, setleavestatus] = useState("")
      const [empCode, setempcode] = useState('')
      const [leave, setleave] = useState('')
      const [leavests, setleavests] = useState('');
      const [id, setid] = useState('')
      const [statusList, setStatusList]: any = useState([]);
      const [showTable, setShowTable] = useState(false);
      //const ids: any = location.state

      //-------------------search Date Api----------------//

      useEffect(() => {

            GetStatusList();



      }, []);

      const Search = () => {
            if (!fromDate) {
                swal("", "Please Select From Date", 'info');
                return;
            }
            if (!toDate) {
                swal("", "Please Select To Date", 'info');
                return;
            }
        
            setloading(true);
            service.EmployeeLeaveUpdate(fromDate, toDate, ids)
                .then((response) => {
                    console.log(response.data);
                    if (response.data.status === "200") {
                        setData(response.data.data);
                        setShowTable(true);
                        console.log("response", response.data);
                    } else if (response.data.status === "400") {
                     
                        swal("Error", response.data.message, "error")
                            .then(() => {
                                setFromDate(""); 
                                setToDate("");  
                                window.location.reload() 
                            });
                        setShowTable(false);
                    }
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    setTimeout(() => {
                        setloading(false);
                    }, 500);
                });
        };
        

      //------------------Search Filter------------------//

      const datatable = Array.isArray(data)
            ? data.filter((item: any) =>
                  JSON.stringify(item).toLowerCase().includes(filterText.toLowerCase())
            )
            : [];


      const paginationComponentOptions = {
            selectAllRowsItem: true,
            selectAllRowsItemText: "ALL"
      };
      const subHeaderComponent = useMemo(() => {
            const handleClear = () => {
                  if (filterText) {
                        setResetPaginationToggle(!resetPaginationToggle);
                        setFilterText("");
                  }

            };

            return (
                  <div style={{ display: "flex" }}>
                        <div style={{ display: "flex" }}>
                              <div className="form-group form-focus row">
                                    <IonInput type="text" className="form-control floating" onIonChange={(e: any) => setFilterText(e.target.value)}
                                          value={filterText} placeholder="Search" />
                                    <label className="focus-label">Search</label>
                              </div>
                              <button type="button" style={{ backgroundColor: "orange", width: "45px", marginTop: "4px", height: "40px", position: 'absolute' }} onClick={handleClear}>X</button>
                        </div>
                  </div>
            )

      }, [filterText, resetPaginationToggle]);

      //----------------------LeaveHistory Datatable---------------//

      const columns: any = [
            {
                  name: "S.No",
                  selector: (itm: any, i: any) => itm.serial,
                  sortable: true,
                  width: "100px",
            },
            {
                  name: "Employee Name",
                  sortable: true,
                  width: "250px",
                  cell: (itm: any) => (
                        <>
                              <div>{itm.empName}{" ("}{itm.empCode}{")"}</div>
                        </>
                  )
            },
            {
                  name: "Leave Type ",
                  selector: (itm: any) => itm.leaveType.leaveType,
                  sortable: true,
            },
            {
                  name: "From Date",
                  selector: (itm: any) => moment(itm.fromDate).format("DD-MM-YYYY"),
                  sortable: true,
                  // width: "150px"
            },
            {
                  name: "To Date",
                  selector: (itm: any) => moment(itm.toDate).format("DD-MM-YYYY"),
                  sortable: true,
                  // width: "150px"
            },
            {
                  name: "No Of Days",
                  selector: (itm: any) => itm.noOfDays,
                  sortable: true,
                  // width: "100px"
            },
            {
                  name: "Status",
                  sortable: true,
                  cell: (itm: any) => (
                        <>
                              <IonText className={itm.leaveStatus.status === "Approved" ? "color_approve" : itm.leaveStatus.status === "Open" ? "color_progress" : "color_deny"}>{itm.leaveStatus.status}</IonText>
                        </>
                  )
            },
            {
                  name: "Action",
                  sortable: false,
                  cell: (itm: any) => (
                        <>
                              <div style={{ textDecoration: 'underline', textDecorationColor: "coral", textUnderlinePosition: "under" }}>
                                    <IonText onClick={() => View(itm.id)} style={{ color: "coral", cursor: 'pointer' }}>View</IonText>
                              </div>
                        </>
                  )
            }
      ];

      const customStyles = {
            headRow: {
                  style: {
                  },
            },
            headCells: {
                  style: {
                        fontWeight: "bold",
                        fontSize: "15px",
                        justifyContent: "center"
                  },
            },
            cells: {
                  style: {
                        fontSize: "16px",
                        justifyContent: "center"
                  }
            }
      };

      //------------------------View Api------------------------//

      const View = (id: any) => {
            setModalopen(true)
            service.GetLeaveDetailsById(id)
                  .then((response) => {
                        console.log(response, "lmlml")
                        if (response.data.Status === "200") {
                              setLeaveType(response.data.Data.leaveType.leaveType);
                              setleave(response.data.Data.leaveType.id)
                              setStatus(response.data.Data.leaveStatus.status);
                              setFDate(response.data.Data.fromDate);
                              setTDate(response.data.Data.toDate);
                              setEmpName(response.data.Data.empName)
                              setLeaveReason(response.data.Data.reason);
                              setReportingPerson(response.data.Data.reportingPerson[0])
                              setNoOfDays(response.data.Data.noOfDays);
                              setRemarks(response.data.Data.remarks);
                              setempcode(response.data.Data.empCode);
                              setleavestatus(response.data.Data.leaveStatus.id)
                              setid(response.data.Data.id)
                        }
                  })
                  .catch((error) => {
                        console.log(error)
                  })
      }

      const closemodal = () => {
            setModalopen(false);
            setLeaveType("");
            setStatus("");
            setFromDate("");
            setTDate("");
            setFDate("");
            setLeaveReason("");
            setReportingPerson("");
            setNoOfDays("");
            setRemarks("");
      }
      const back = () => {
            history.goBack();
      }

      const EmployeeLeaveUpdate = () => {
            var nodFloat = parseFloat(NoOfDays);
            service.EmployeeUpdateview(id,nodFloat, fDate, tDate, leave, leaveReason, leavestatus, empCode, true)
                .then((response) => {
                    console.log(response);
                  
                    if (response.data && response.data.Status) {
                        if (response.data.Status === '200') {
                            swal("", response.data.Message, "success")
                                .then(() => {
                                    window.location.reload();
                                });
                        } else if (response.data.Status === '400') {
                            swal("", response.data.Message, 'error');
                        }
                    } else {
                      
                        closemodal();  
                    }
                
                    
                })
                .catch((error) => {
                    console.error(error);
                    swal("Error", "Something went wrong. Please try again.", "error");
                });
        };
        
        
      const GetStatusList = () => {
            service.GetLeaveStatusDropDown()
                  .then((response) => {
                        console.log(response);
                        if (response.data.Status === "200") {
                              setStatusList(response.data.Data);
                        }
                        else {
                              setStatusList([]);
                        }
                  })
      }
      const CancelLeave = () => {
            var nodFloat = parseFloat(NoOfDays);
            swal({
                  title: "Do you want to Cancel your leave?",
                  icon: "warning",
                  dangerMode: true,
                  buttons: {
                        confirm: {
                              text: "Yes",
                              value: true,
                              visible: true,
                              className: "custom-swal-yes",
                              closeModal: true,
                        },
                        cancel: {
                              text: "No",
                              value: false,
                              visible: true,
                              className: "",
                              closeModal: true,

                        },
                  },
            })
                  .then((willDelete) => {
                        var sts: any;
                        for (let i = 0; i < statusList.length; i++) {
                              if (statusList[i].status === "Cancelled") {
                                    sts = statusList[i].id
                              }
                        }
                        if (willDelete) {
                              service.EmployeeUpdatecancel(id, nodFloat, fDate, tDate, leave, leaveReason, sts, empCode, false)
                                    .then((response) => {
                                          console.log(response)
                                          console.log("status is", sts)
                                          if (response.data.Status === "200") {
                                                swal("", response.data.Message, "success")
                                                      .then(() => {
                                                            window.location.reload();
                                                      });
                                          }
                                    })
                                    .catch((error) => {
                                          console.log(error)
                                    })
                        }
                  });

      }
      return (
            <IonPage>
                  <Head />
                  <Sidebar />
                  <IonContent>
                        <div className="page-wrapper">
                              <div className="page-header">
                                    <div className="content container-fluid">
                                          <div className="row align-items-center">
                                                <div className="col">
                                                      <h3 className="page-title" style={{ fontWeight: "bold" }}>
                                                            <i className="fa fa-arrow-left" onClick={back} style={{ color: "black", cursor: "pointer", marginRight: "5px" }} />
                                                            Employee Leave Update</h3>
                                                </div>
                                          </div>
                                          <div className="row filter-row" style={{ marginTop: "3%" }}>
                                                <div className="col-sm-4 col-md-4">
                                                      <div className="form-group">
                                                            <label style={{ fontWeight: "bold" }}> From Date <span className="text-danger">*</span></label>
                                                            <div>
                                                                  <IonInput type="date" onIonChange={(e: any) => setFromDate(e.detail.value)} className="form-control datetimepicker" />
                                                            </div>
                                                      </div>
                                                </div>
                                                <div className="col-sm-4 col-md-4">
                                                      <div className="form-group">
                                                            <label style={{ fontWeight: "bold" }}> To Date <span className="text-danger">*</span></label>
                                                            <div>
                                                                  <IonInput type="date" onIonChange={(e: any) => setToDate(e.detail.value)} min={fromDate} className="form-control datetimepicker" />
                                                            </div>
                                                      </div>
                                                </div>
                                                <div className="col-sm-4 col-md-4" style={{ display: "flex", alignSelf: "center", justifySelf: "center" }}>
                                                      <a onClick={() => Search()} className="btn btn-success btn-block w-100"> Search </a>
                                                </div>
                                          </div>

                                          {loading && (
                                                <div
                                                      style={{
                                                            position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999
                                                      }}
                                                >
                                                      <div >
                                                            <IonSpinner style={{
                                                                  width: "40px",
                                                                  height: "40px",
                                                                  color: "#ff8a53"
                                                            }} name="lines" />
                                                      </div>
                                                </div>
                                          )}
                                             {showTable && (
                                          <div className="table-responsive">
                                                <DataTable
                                                      columns={columns}
                                                      data={datatable}
                                                      pagination
                                                      paginationPerPage={10}
                                                      paginationComponentOptions={paginationComponentOptions}
                                                      paginationRowsPerPageOptions={[10, 20, 30]}
                                                      subHeader
                                                      subHeaderComponent={subHeaderComponent}

                                                      customStyles={customStyles}
                                                />
                                          </div>
                                             )}
                                    </div>
                              </div>
                        </div>
                        <Modal
                              dialogClassName="my-modal modal-dialog-centered"
                              // id="logouts-modal"
                              show={modalopen}
                        >
                              <div className="modal-header">
                                    <h5 className="modal-title">View Leave</h5>
                                    <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close" onClick={() => closemodal()}>
                                          <span aria-hidden="true">×</span>
                                    </button>
                              </div>
                              <div className="modal-body">
                                    <form>
                                          <div className="col-md-12">
                                                <div className="row">
                                                      <div className="col-lg-4">
                                                            <div className="form-group">
                                                                  <label style={{ fontWeight: "bold" }}> Employee Name </label>
                                                                  <div>
                                                                        <IonInput value={empName} readonly className="form-control" />
                                                                  </div>
                                                            </div>
                                                      </div>
                                                      <div className="col-lg-4">
                                                            <div className="form-group">
                                                                  <label style={{ fontWeight: "bold" }}>Leave Type </label>
                                                                  <div>
                                                                        <IonInput value={leaveType} readonly className="form-control" />
                                                                  </div>
                                                            </div>
                                                      </div>
                                                      <div className="col-lg-4">
                                                            <div className="form-group">
                                                                  <label style={{ fontWeight: "bold" }}>From Date </label>
                                                                  <div>
                                                                        <IonInput value={fDate} onIonChange={(e: any) => setFDate(e.detail.value)} className="form-control datetimepicker" type="date" />
                                                                  </div>
                                                            </div>
                                                      </div>

                                                </div>
                                                <div className="row">
                                                      <div className="col-lg-4">
                                                            <div className="form-group">
                                                                  <label style={{ fontWeight: "bold" }}>To Date </label>
                                                                  <div>
                                                                        <IonInput value={tDate} onIonChange={(e: any) => setTDate(e.detail.value)} className="form-control datetimepicker" type="date" />
                                                                  </div>
                                                            </div>
                                                      </div>
                                                      <div className="col-lg-4">
                                                            <div className="form-group">
                                                                  <label style={{ fontWeight: "bold" }}>No Of Days </label>
                                                                  <IonInput value={NoOfDays} onIonChange={(e: any) => setNoOfDays(e.detail.value)} className="form-control" />
                                                            </div>
                                                      </div>
                                                      <div className="col-lg-4">
                                                            <div className="form-group">
                                                                  <label style={{ fontWeight: "bold" }}>Status </label>
                                                                  <div>
                                                                        <IonInput value={status} readonly className="form-control" />
                                                                  </div>
                                                            </div>
                                                      </div>


                                                </div>
                                                <div className="row">
                                                      <div className="col-lg-4">
                                                            <div className="form-group">
                                                                  <label style={{ fontWeight: "bold" }}>Reason for Leave </label>
                                                                  <IonInput value={leaveReason} readonly className="form-control" />
                                                            </div>
                                                      </div>
                                                      <div className="col-lg-4">
                                                            <div className="form-group">
                                                                  <label style={{ fontWeight: "bold" }}>Reporting Person's </label>
                                                                  <IonInput value={reportingPerson} readonly className="form-control" />
                                                            </div>
                                                      </div>
                                                      <div className="col-lg-4">
                                                            <div className="form-group">
                                                                  <label style={{ fontWeight: "bold" }}>Remarks </label>
                                                                  <IonInput value={remarks} readonly className="form-control" />
                                                            </div>
                                                      </div>
                                                </div>
                                          </div>
                                          <div className="row-leave" style={{ display: "flex", justifyContent: "center", marginTop: "10%" }}>
                                                {status === 'cancelled' ? (
                                                      <button
                                                            type="button"
                                                            className="btn-primary btn-lg"
                                                            style={{ fontSize: "15px", height: "40px", flex: 1, margin: "0 5px" }}
                                                            onClick={closemodal}
                                                      >
                                                            Back
                                                      </button>
                                                ) : (
                                                      <>
                                                            <button
                                                                  type="button"
                                                                  className="btn-primary btn-lg"
                                                                  style={{ fontSize: "15px", height: "40px", flex: 1, margin: "0 5px" }}
                                                                  onClick={closemodal}
                                                            >
                                                                  Back
                                                            </button>
                                                            <button
                                                                  type="button"
                                                                  className="btn-primary btn-lg"
                                                                  style={{ fontSize: "15px", height: "40px", flex: 1, margin: "0 5px" }}
                                                                  onClick={EmployeeLeaveUpdate}
                                                            >
                                                                  Update
                                                            </button>
                                                            <button
                                                                  type="button"
                                                                  className="btn-danger btn-lg"
                                                                  style={{ fontSize: "15px", height: "40px", flex: 1, margin: "0 5px" }}
                                                                  onClick={CancelLeave}
                                                            >
                                                                  Cancel Leave
                                                            </button>
                                                      </>
                                                )}
                                          </div>

                                    </form>
                              </div>
                        </Modal>
                  </IonContent>
            </IonPage>
      )
}

export default EmpLeaveUpdateView;